export default __webpack_public_path__ + "static/media/Shield of the Fallen Empire.fce7d5f3.jpg";